<template>
  <div>
    <div v-if="formHtml" v-html="formHtml"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: mapGetters({
    formHtml: 'stepFormHtmlDecoded',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Form.vue?9b2f5760
 **/